import { render, staticRenderFns } from "./ProductOptionItem.vue?vue&type=template&id=b6cd1b1a&scoped=true&"
import script from "./ProductOptionItem.vue?vue&type=script&lang=js&"
export * from "./ProductOptionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cd1b1a",
  null
  
)

export default component.exports